module.exports = __webpack_public_path__ + "img/b1c62eca7e91f5be6be832f94a763217.a005cd8e.jpg";